const defaultOffset = { height: 0, width: 0 };
export {
  defaultOffset
};
//# sourceMappingURL=defaultOffset.js.map
